import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, Hidden as BaseHidden } from '@material-ui/core'

export const Image = styled.img`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Label = styled.label`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
`

export const Root = styled.div`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 'initial'};
    max-width: ${props => props.maxWidth || 'initial'};
    padding: ${props => props.padding || '0'};
    text-align: left;
  }

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Instructions = styled.section`
  margin-top: 28px;
  font-size: 22px;
  line-height: 26px;
  font-weight: 300;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const SpinnerRoot = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Hidden = styled(BaseHidden)``
